export const toNumber = (candidate): number => parseFloat(candidate)
export const isNumber = (candidate) => !isNaN(toNumber(candidate))
